import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
//UI
import logo from '../../../assets/peef.png';
import { FaArrowLeft } from 'react-icons/fa';
//TRASLATION
import { useTranslation } from "react-i18next";
//SLICE
import { ForgotPasswordParent } from '../../../store/slices/public/parents.slice';
import { getConfigsThunk, initialStateConfig } from '../../../store/slices/catalogs/config.slice';
import { API_BASE_URL } from '../../../store/constans';
import MainLoader from '../../../components/Loaders/MainLoader';


const ForgotPasswordPublic = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const userState = useSelector(state => state.parents)
    const { items } = useSelector(state => state.configurations);
    const isLoading = useSelector(state => state.isLoadingSlice);
    const onSubmit = (data) => {
        dispatch(ForgotPasswordParent(data));
    };

    useEffect(() => {
        dispatch(getConfigsThunk());
        return () => {
            dispatch(initialStateConfig())
        }
    }, []);

    return (
        <>
            {isLoading ? (<MainLoader />) : (
                <div
                    className={`text-gray-600 flex justify-center items-center 2xl:items-center transition-all h-full w-full min-h-screen bg-cover bg-center`}
                    style={{ backgroundImage: `url(${API_BASE_URL + items[0]?.background})` }}
                >
                    <div className="absolute top-0 left-0 w-full h-full bg-zinc-800/40 "></div>
                    <div className="w-full font-sans transition-all md:w-[35%] rounded-md bg-white/80 backdrop-blur-lg shadow-md shadow-gray-800 flex flex-col items-center justify-center">
                        {userState.message === "password updated successfully" ?
                            <>
                                <div className='flex flex-col p-2 w-[80%] border-sky-500 rounded-md border bg-sky-200 mt-10 '>
                                    <h1 className="text-center font-semibold text-[14px] mb-5">Se ha enviado un email a la dirección de correo electrónico ingresada, con una contraseña temporal con la que podrás iniciar sesión y restablecer tu contraseña</h1>
                                    <div className='pl-2 text-[13px]'>
                                        <p className='mb-0'>Nota: Si no encuentras nuestro email en tu bandeja de entrada, por favor revisa la bandeja de spam o correo no deseado</p>
                                    </div>
                                </div>
                                <div className='flex gap-2 w-[100%] my-10 justify-center'>
                                    <h1 className="text-[14px] flex gap-2"><Link to={'/'}><p className='text-sky-700 hover:text-sky-800 flex items-center gap-1'><FaArrowLeft /> Iniciar sesión</p> </Link></h1>
                                </div>
                            </> :
                            <>
                                <div className='flex flex-col w-full items-center justify-center text-[15px] text-sky-800 text-center gap-2 my-10'>
                                    <h1 className="text-[18px] font-semibold ">¿Olvidaste tu contraseña?</h1>
                                    <p className='px-8'>Ingrese su Cédula / Pasaporte / RUC asociado con su cuenta y le enviaremos un enlace por correo electrónico para restablecer su contraseña.</p>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit)} className="w-2/3 max-w-xs mx-auto mb-16">
                                    <div className="relative flex flex-col mt-8">
                                        <input className={'w-full placeholder-gray-600 p-2 rounded-xl focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'}
                                            type='text'
                                            {...register("ciParent", { required: true })}
                                            placeholder="Cédula / Pasaporte / RUC"
                                        />
                                    </div>
                                    {errors.email && <span className="text-red-600 text-xs pl-2">{t("required_information")}</span>}
                                    <button type="submit" className="btn shadow-lg btn-block bg-sky-700 hover:bg-sky-800 border-none rounded-md mt-16 text-white">
                                        Restablecer contraseña
                                    </button>
                                    <div className='flex gap-2 w-[100%] mt-5 justify-center'>
                                        <h1 className="text-[14px] flex gap-2"><Link to={'/'}><p className='text-sky-700 hover:text-sky-800 flex items-center gap-1'><FaArrowLeft /> Iniciar sesión</p> </Link></h1>
                                    </div>
                                </form>
                            </>}
                    </div >
                    <div className="hidden md:flex md:flex-col md:absolute bg-white/80 absolute md:left-[90%] md:top-[80%] z-10 p-2 rounded-md shadow-md shadow-gray-500">
                        <img className='w-[280px] md:w-[100px]' src={logo} alt="logo" />
                        <p className='font-semibold text-[13px]'>Proveedor Oficial</p>
                    </div>
                </div >
            )}
        </>
    );
};

export default ForgotPasswordPublic;